'use client';

import { DateCalendarIcon } from '@/components';
import { Box, Button, InputAdornment, Popover, TextField } from '@mui/material';
import { FC, useState } from 'react';

const CURRENT_YEAR = new Date().getFullYear();
const YEARS = Array.from({ length: CURRENT_YEAR - 1950 + 1 }, (_, i) => String(CURRENT_YEAR - i));

type YearPickerFieldProps = {
  value: string;
  onChange: (year: string) => void;
  label: string;
};

export const YearPickerField: FC<YearPickerFieldProps> = ({ value, onChange, label }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  return (
    <>
      <TextField
        value={value}
        size="small"
        label={label}
        fullWidth
        onClick={(e) => setAnchorEl(e.currentTarget)}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              <DateCalendarIcon width={20} height={20} />
            </InputAdornment>
          ),
        }}
        sx={{ cursor: 'pointer', '& input': { cursor: 'pointer' } }}
      />
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <Box sx={{ p: 1.5, width: 260, maxHeight: 280, overflow: 'auto' }}>
          <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 0.5 }}>
            {YEARS.map((year) => (
              <Button
                key={year}
                size="small"
                variant={year === value ? 'contained' : 'text'}
                onClick={() => {
                  onChange(year);
                  setAnchorEl(null);
                }}
                sx={{ minWidth: 0 }}
              >
                {year}
              </Button>
            ))}
          </Box>
        </Box>
      </Popover>
    </>
  );
};
